import controller from './faq.controller';
import template from './faq.html';

const faqComponent = {
  restrict: 'E',
  bindings: {},
  controller,
  template
};

export default faqComponent;



/** WEBPACK FOOTER **
 ** ./client/app/components/faq/faq.component.js
 **/